var _rect, _rect2, _path, _rect3, _rect4, _rect5, _mask, _path2, _path3, _rect6, _rect7, _rect8, _rect9, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCtEMenuLateral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.52539,
    y: 17.75,
    width: 3.875,
    height: 6.75,
    rx: 1.5,
    fill: "white",
    stroke: "#364863"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1758,
    y: 17.75,
    width: 3.875,
    height: 6.75,
    rx: 1.5,
    fill: "white",
    stroke: "#364863"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2875 7.97461C21.8526 7.97461 21.5 8.32719 21.5 8.76211V9.91211C21.5 10.347 21.8526 10.6996 22.2875 10.6996C22.7224 10.6996 23.075 10.347 23.075 9.91211V8.76211C23.075 8.32719 22.7224 7.97461 22.2875 7.97461Z",
    fill: "white",
    stroke: "#364863"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 7.97461,
    width: 1.575,
    height: 2.725,
    rx: 0.7875,
    fill: "white",
    stroke: "#364863"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.375,
    y: 0.5,
    width: 18.825,
    height: 17.675,
    rx: 1.5,
    fill: "white",
    stroke: "#364863"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.80078,
    y: 14.875,
    width: 19.975,
    height: 7.325,
    rx: 1.5,
    fill: "white",
    stroke: "#364863"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-outside-1_10077_10245",
    maskUnits: "userSpaceOnUse",
    x: 1.29883,
    y: 4.02441,
    width: 21,
    height: 17,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1.29883,
    y: 4.02441,
    width: 21,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59883 5.02441C5.04654 5.02441 4.59883 5.47213 4.59883 6.02441V15.3744H3.29883C2.74654 15.3744 2.29883 15.8221 2.29883 16.3744V18.3994C2.29883 18.9517 2.74654 19.3994 3.29883 19.3994H5.59883H17.9738H20.2738C20.8261 19.3994 21.2738 18.9517 21.2738 18.3994V16.3744C21.2738 15.8221 20.8261 15.3744 20.2738 15.3744H18.9738V6.02441C18.9738 5.47213 18.5261 5.02441 17.9738 5.02441H5.59883Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59883 5.02441C5.04654 5.02441 4.59883 5.47213 4.59883 6.02441V15.3744H3.29883C2.74654 15.3744 2.29883 15.8221 2.29883 16.3744V18.3994C2.29883 18.9517 2.74654 19.3994 3.29883 19.3994H5.59883H17.9738H20.2738C20.8261 19.3994 21.2738 18.9517 21.2738 18.3994V16.3744C21.2738 15.8221 20.8261 15.3744 20.2738 15.3744H18.9738V6.02441C18.9738 5.47213 18.5261 5.02441 17.9738 5.02441H5.59883Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59883 15.3744V16.3744H5.59883V15.3744H4.59883ZM18.9738 15.3744H17.9738V16.3744H18.9738V15.3744ZM5.59883 6.02441V6.02441V4.02441C4.49426 4.02441 3.59883 4.91985 3.59883 6.02441H5.59883ZM5.59883 15.3744V6.02441H3.59883V15.3744H5.59883ZM3.29883 16.3744H4.59883V14.3744H3.29883V16.3744ZM3.29883 16.3744V14.3744C2.19426 14.3744 1.29883 15.2698 1.29883 16.3744H3.29883ZM3.29883 18.3994V16.3744H1.29883V18.3994H3.29883ZM3.29883 18.3994L3.29883 18.3994H1.29883C1.29883 19.504 2.19426 20.3994 3.29883 20.3994V18.3994ZM5.59883 18.3994H3.29883V20.3994H5.59883V18.3994ZM17.9738 18.3994H5.59883V20.3994H17.9738V18.3994ZM20.2738 18.3994H17.9738V20.3994H20.2738V18.3994ZM20.2738 18.3994V18.3994V20.3994C21.3784 20.3994 22.2738 19.504 22.2738 18.3994H20.2738ZM20.2738 16.3744V18.3994H22.2738V16.3744H20.2738ZM20.2738 16.3744H20.2738H22.2738C22.2738 15.2698 21.3784 14.3744 20.2738 14.3744V16.3744ZM18.9738 16.3744H20.2738V14.3744H18.9738V16.3744ZM17.9738 6.02441V15.3744H19.9738V6.02441H17.9738ZM17.9738 6.02441V6.02441H19.9738C19.9738 4.91984 19.0784 4.02441 17.9738 4.02441V6.02441ZM5.59883 6.02441H17.9738V4.02441H5.59883V6.02441Z",
    fill: "#364863",
    mask: "url(#path-7-outside-1_10077_10245)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.40039,
    y: 6.8252,
    width: 10.775,
    height: 6.75,
    rx: 1.5,
    stroke: "#364863"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.127,
    y: 10.7754,
    width: 1.15,
    height: 4.025,
    rx: 0.575,
    transform: "rotate(49.8399 11.127 10.7754)",
    fill: "#364863"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5762,
    y: 10.7754,
    width: 1.15,
    height: 4.025,
    rx: 0.575,
    transform: "rotate(49.8399 14.5762 10.7754)",
    fill: "#364863"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.67188,
    y: 17.6875,
    width: 1.15,
    height: 4.025,
    rx: 0.575,
    transform: "rotate(-90 9.67188 17.6875)",
    fill: "#364863"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.75078,
    cy: 17.1004,
    r: 1.075,
    stroke: "#364863"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.825,
    cy: 17.1004,
    r: 1.075,
    stroke: "#364863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCtEMenuLateral);
export default __webpack_public_path__ + "static/media/icon-ct-e-menu-lateral.d8051d759a10467f1070ce4e01f4b094.svg";
export { ForwardRef as ReactComponent };